import api from './Api'; // Import the pre-configured axios instance

const FolderService = {
    /**
     * Fetches the list of folders from the backend using the shared Axios instance.
     * @returns {Promise<Array<Object>>} A promise that resolves to an array of folder objects.
     */
    fetchFolders: async () => {
        try {
            // Use the 'api' instance directly. The base URL is already configured.
            const response = await api.get('/folders');
            return response.data['data'];
        } catch (error) {
            console.error('Error in fetchFolders:', error.response ? error.response.data : error.message);
            throw error; // Re-throw to be caught by the component
        }
    },



    /**
     * Creates a new folder on the backend using the shared Axios instance.
     * @param {string} folderName The name of the new folder.
     * @returns {Promise<Object>} A promise that resolves to the created folder object.
     */
    createFolder: async (folderName) => {
        try {
            // Use the 'api' instance directly. The base URL and default headers are already configured.
            const response = await api.post('/folders', { name: folderName });
            return response.data; // Axios automatically parses JSON into .data
        } catch (error) {
            console.error('Error in createFolder:', error.response ? error.response.data : error.message);
            throw error;
        }
    },
};

export default FolderService;
